/**
 * premiumError — Stream H (R4)
 *
 * Das Backend praezisiert seit R4 den Premium-Gate-Fall: statt den Schalter fuer
 * Free-Accounts nur auszublenden (v1), antwortet es auf einen Schreibversuch mit
 * 403 { success: false, error: { code: 'premium_required', message } }.
 * Ohne Auswertung dieses Codes wirken die betroffenen Bedienelemente stumm.
 *
 * R4-Review F1: `apiClient` wirft bei HTTP >= 400 eine `ApiError`, deren
 * Response-Body unter `.body` haengt — das rohe Body-Shape liegt also NICHT
 * direkt auf dem geworfenen Fehler. Die Code-Extraktion laeuft deshalb ueber
 * den zentralen Helper `apiErrorCode`, der ApiError-Instanzen, `{ body }`-
 * Huellen und rohe Bodies gleichermassen versteht (und den Code normalisiert).
 *
 * Review-Fix (premium-gates): das eigentliche Premium-Gate (B1,
 * PremiumGate-Concern) antwortet mit 402 { error: { code: 'premium_required',
 * message } } — echte Shape ist also verschachtelt wie der R4-Fall oben,
 * nur mit Status 402 statt 403. `apiErrorCode` deckt das bereits ab (Status
 * ist ihr egal). Zusaetzlich erkannt: ein (bisher nicht beobachteter)
 * flacher `body.error === 'premium_required'`-String.
 *
 * Review-Fix 2 (premium-gates): der Fallback "Status 402 ohne erkennbaren
 * Code = Premium-Gate" wurde WIEDER ENTFERNT — 402 wird auch fuer andere
 * Faelle genutzt (z. B. `subscription_required`, `requires_action`), die
 * NICHT das Premium-Gate sind. Erkennung ist daher ausschliesslich
 * code-basiert (verschachtelt oder flach), niemals allein am Status.
 */
import { apiErrorCode, bodyOf } from './errors/apiErrorMessage'

export const PREMIUM_REQUIRED_CODE = 'premium_required'

/** Erkennt den Premium-Gate-Fehler unabhaengig von Status/Fehlerhuelle. */
export function isPremiumRequiredError(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false
  const code = apiErrorCode(err)
  if (code === PREMIUM_REQUIRED_CODE) return true
  return bodyOf(err).error === PREMIUM_REQUIRED_CODE
}
